import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve, Router } from "@angular/router";
import { ClientModel } from "../models/client.model";
import { ClientService } from "../services/client.service";
import { StorageService } from "../services/storage.service";

@Injectable()
export class ClientsResolver implements Resolve<ClientModel[]> {

    constructor(
        private storageService: StorageService,
        private clientService: ClientService,
        private router: Router
    ) { }

    resolve(route: ActivatedRouteSnapshot) {
        return new Promise<ClientModel[]>((resolve, reject) => {
            this.clientService.all().then(
                result => {

                    resolve(result);

                    let url = this.router.routerState.snapshot.url;

                    const inCodeExchange = url.startsWith('/auth/exchange');

                    if (url === '' || url === '/auth/login' || inCodeExchange) {
                        this.storageService.setItem("client", result[0].clientId);
                        this.router.navigate(['/portal', result[0].clientId]);
                    }
                },
                error => reject(error)
            )
        });
    }
}
